import IParser from "@/types/IParser"
import { ThrottleConfigResponse } from "@/api/backofficeRest/generated/model"
import { IThrottleConfig } from "./throttleConfig.types"
import { ThrottleConfig } from "./throttleConfig"

export type ThrottleConfigRaw = ThrottleConfigResponse

export const ThrottleConfigParser: IParser<IThrottleConfig, ThrottleConfigRaw> =
  {
    toDomain(data: ThrottleConfigRaw): IThrottleConfig {
      return new ThrottleConfig(
        data.id,
        data.communicationId,
        data.communicationName,
        data.maxPerWindow,
        data.windowSeconds,
        data.enabled,
      )
    },
  }
